import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JsonEditorVue = _resolveComponent("JsonEditorVue")!

  return (_openBlock(), _createBlock(_component_JsonEditorVue, {
    modelValue: _ctx.jsonData,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jsonData) = $event)),
    "navigation-bar": false,
    "main-menu-bar": false,
    "read-only": true
  }, null, 8 /* PROPS */, ["modelValue"]))
}